<template>
  <section class="checkbox-list">
    <b-checkbox
      v-for="checkbox in value"
      v-model="checkbox.data"
      :key="checkbox.label">
      {{ checkbox.label }}
    </b-checkbox>
  </section>
</template>

<script>
export default {
  name: 'c-multi-checkbox',
  props: ['value'],
}
</script>

<style scoped>
.checkbox-list {
  padding-top: 0.375em;
}
</style>



// WEBPACK FOOTER //
// src/lib/components/MultiCheckbox.vue